export default {
  pageNavbar: [
    {
      name: "Wyposażenie wnętrza",
      anchor: "interior"
    },
    {
      name: "Elektryczne Ogrzewanie",
      anchor: "equipment"
    },
    {
      name: "Komfort",
      anchor: "comfort"
    },
    {
      name: "Komfort",
      anchor: "more"
    },
    {
      name: "Lampy BI-LED",
      anchor: "bi-led"
    },
    {
      name: "Inne",
      anchor: "features"
    }
  ],
  headerDesc:
    "Kabina Eclipse Cross PHEV została zaprojektowana z myślą o komforcie kierowcy oraz pasażerów. Obsługa systemów pokładowych jest intuicyjna, a przełączniki zostały rozmieszczone w przejrzysty sposób. Wysokiej jakości materiały wykończeniowe, w tym elementy wykonane ze skóry, duża ilość miejsca na nogi oraz doskonały system audio potęgują wrażenie luksusu.",
  headerButton: "Zobacz wideo",
  headerMovieDesc: [
    {
      header: "SYSTEM DOSTĘPU BEZKLUCZYKOWEGO [KOS]",
      desc:
        "Mając przy sobie kluczyk, wystarczy nacisnąć przycisk na zewnętrznej klamce drzwi kierowcy lub pokrywie bagażnika, aby zablokować lub odblokować zamki. Do uruchamiania i wyłączania pojazdu służy przycisk POWER."
    },
    {
      header: "PODGRZEWANA KIEROWNICA",
      desc:
        "Podgrzewana kierownica zwiększa komfort prowadzenia pojazdu w chłodne dni. Przełącznik uruchamiający ogrzewanie umieszczono na środkowym panelu."
    },
    {
      header: "TYLNE NAWIEWY POWIETRZA",
      desc:
        "W tylnej konsoli znajdują się regulowane nawiewy, zapewniające komfort pasażerom siedzącym z tyłu."
    },
    {
      header: "ELEKTRYCZNY HAMULEC POSTOJOWY Z FUNKCJĄ AUTO HOLD",
      desc:
        "Hamulcem postojowym w konsoli podłogowej łatwo operować dzięki stylowemu przełącznikowi. W celu włączenia hamulca postojowego należy pociągnąć przełącznik do góry, a w celu zwolnienia hamulca należy wcisnąć przełącznik."
    },
    {
      header: "ELEKTRYCZNA REGULACJA PODPARCIA LĘDŹWIOWEGO",
      desc:
        "Elektryczna regulacja podparcia lędźwiowego odcinka kręgosłupa pozwala na łatwą regulację głębokości oparcia w kierunku przód i tył, pomagając zmniejszyć obciążenie dolnej części pleców w celu zwiększenia komfortu jazdy. Opcja ta, wraz z innymi funkcjami foteli, pomaga wybrać optymalną dla Twojej budowy fizycznej pozycję za kierownicą."
    }
  ],
  textWitVideoSubHeader:
    "Przewiń w dół, aby sprawdzić, co jeszcze oferuje Eclipse Cross PHEV.",
  textWitVideoHeader: "Najciekawsze elementy wyposażenia",
  textWitVideoDesc:
    "Elektryczna nagrzewnica pozwala wytworzyć ciepło niezbędne do ogrzania kabiny pasażerskiej bez konieczności uruchamiania silnika spalinowego. Z ogrzewania można zatem korzystać także rano lub późnym wieczorem bez niepokojenia sąsiadów hałasem silnika. W wyjątkowo mroźną pogodę nagrzewnica elektryczna może także wspomagać tradycyjne ogrzewanie oparte na cieple odbieranym z silnika spalinowego.",
  comfortSubHeader: "Dla twojej wygody",
  comfortHeader: "Przestronność, komfort i wyrafinowanie",
  comfortDesc:
    "Wejdź do oazy komfortu i wyrafinowania, która dodatkowo zwiększa przyjemność jazdy swoją przestronnością, luksusowymi udogodnieniami i niezwykle cichą pracą silnika. Wszystkie siedzenia mają dopracowane wykończenia z materiałów wysokiej jakości. Przednie fotele otaczają ciało z każdej strony, natomiast pasażerowie na tylnych podgrzewanych siedzeniach mogą cieszyć się dużą ilością miejsca na nogi. Jazda SUV-em jeszcze nigdy nie była tak odprężająca.",
  biLedHeaderSub: "Światła",
  biLedHeader:
    "Lampy BI-LED ze światłami do jazdy dziennej i przednimi światłami przeciwmgielnymi",
  biLedDesc:
    "Nowe, stylowe reflektory są wyposażone w oświetlenie LED zarówno w światłach drogowych, jak i światłach mijania. Światła przeciwmgielne LED oświetlają białym światłem drogę przed samochodem.",
  advancedSubHeader: "Wyposażenie wnętrza",
  advancedHeader: "Więcej",
  advancedEasy: "System łączności Mitsubishi remote control",
  advancedEasyDesc:
    "Za pomocą smartfona użytkownik samochodu może zdalnie sterować programatorem czasowym ładowania, zmieniać harmonogram ładowania z uwzględnieniem tańszej taryfy nocnej, monitorować czas pozostały do pełnego naładowania itp. Najnowsza aplikacja Mitsubishi Remote Control umożliwia także sterowanie schładzaniem i nagrzewaniem kabiny, które można uruchomić natychmiast lub o zaprogramowanej godzinie.",
  advancedMode: "FUNKCJONALNY BAGAŻNIK",
  advancedModeDesc:
    "Przestrzeń bagażowa w nowym Eclipse Cross PHEV została powiększona względem jego benzynowego poprzednika. Bagażnik o pojemności 359 litrów (pomiar do górnej krawędzi oparć, bez rolety) ma regularne kształty i pomieści naprawdę wiele. Jeśli to nie wystarczy, zawsze możesz złożyć oparcia tylnej kanapy i w ten sposób uzyskać więcej przestrzeni.",
  advancedPower: "Schowek na przewód do ładowarek",
  advancedPowerDesc:
    "Schowek pod tylną częścią podłogi bagażnika idealnie nadaje się do przewożenia kabla do ładowania.",
  advancedButton: "Zobacz wideo",
  advancedImages: ["advanced-image-first.png", "advanced-image-second.jpg"],
  footerSlider: [
    {
      header: "PODGRZEWANA KIEROWNICA",
      description:
        "Podgrzewana kierownica zwiększa komfort prowadzenia pojazdu w chłodne dni.",
      background: "KIEROWNICA.jpg"
    },
    {
      header: "Wyświetlacz przezierny Head-Up",
      description:
        "Wyświetlacz przezierny pozwala szybko odczytać informacje i alerty dotyczące jazdy. Środowisko przypominające wysoce funkcjonalny kokpit lotniczy w naturalny sposób zwiększa zdolność koncentracji przy prowadzeniu samochodu.",
      background: "headup.jpg"
    },
    {
      header: "ELEKTRYCZNY HAMULEC POSTOJOWY Z FUNKCJĄ AUTO HOLD",
      description:
        "Hamulcem postojowym w konsoli podłogowej łatwo operować dzięki stylowemu przełącznikowi.",
      background: "HAMULEC.jpg"
    },
    {
      header: "Stacja multimedialna SDA",
      description:
        "8-calowy ekran dotykowy oferuje dostęp do wielu funkcji, w tym Apple Car Play i Android Auto. Łączy on użytkownika z samochodem sprawiając, że przestrzeń staje się bardziej osobista, a wrażenia z jazdy są przyjemniejsze.",
      background: "sda.jpg"
    },
    {
      header: "SYSTEM DOSTĘPU BEZKLUCZYKOWEGO",
      description:
        "Mając przy sobie kluczyk, wystarczy nacisnąć przycisk na zewnętrznej klamce drzwi kierowcy lub pokrywie bagażnika, aby zablokować lub odblokować zamki.",
      background: "BEZKLUCZYKOWY.jpg"
    },
    {
      header: "Duża, łatwa w użyciu przestrzeń bagażowa.",
      description:
        "Eclipse Cross PHEV posiada wygodną przestrzeń bagażową, pomieści nie tylko duże zakupy, ale również bagaż całej rodziny podczas wakacyjnego wyjazdu",
      background: "bagaznik.jpg"
    }
  ]
};
